import CarouselHome from "../components/CarouselHome";

import React from "react";
import TextHome from "../components/TextHome";

export default function HomePagePublic() {
  return (
    <div className="my-2">
      <CarouselHome idPage={"home"}></CarouselHome>
      <TextHome idPage={"homepublic"}></TextHome>
    </div>
  );
}
